var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g({staticClass:"uk-link-heading"},_vm.$listeners),[_c('div',{staticClass:"quick-filter-button",style:([ _vm.selected ? { color: _vm.color } : ''])},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }